import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import { ALERT } from '../constants/PropTypesShapes';
import {
  isAlertPopUpClicked,
  isPopUpWindowAlertEnabled,
  renderPopUpFpti,
  setAlertPopUpClickInSession,
} from '../../lib/covidHelper';

class CovidAlertModalContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeModalContainer: false,
    };
  }

  /**
   * When link on Alert pop up is clicked
   */
  handleAlertLinkClick(e, link) {
    // Setting session variable for critical-alert-popup as true when clicked on link
    // So that pop up will not open again
    setAlertPopUpClickInSession(true);
    const href = link.getAttribute('href');
    const { location } = this.props;
    const pathName = (location && location.pathname) || '';
    // fpti Page Id
    const fptiPageId = Page.isContactUsPage() ? 'contactUsAlertPopup' : renderPopUpFpti(pathName);
    if (!href) {
      e.preventDefault();
      trackLink({ id: fptiPageId, link: 'smarthelp-pop-up-critical-alert|broken-link-clicked' });
    } else {
      const faqId = (href.split('-') && href.split('-').pop()) || '';
      trackLink({ id: fptiPageId, link: `smarthelp-pop-up-critical-alert-link-clicked|${href}`, hpid: faqId });
    }
  }

  /**
   * Parsing the links in alert content
   */
  parseContent(alertContent) {
    // Adding setTimeout on top as tag element is not picked immediately safari and IE versions
    setTimeout(() => {
      if (!alertContent) {
        return;
      }

      // Link click Tracking in Article Component
      const contentLinks = alertContent.querySelectorAll('a[href]');
      Array.from(contentLinks).forEach((link) => {
        link.addEventListener('click', (e) => this.handleAlertLinkClick(e, link));
      });
    });
  }

  closeModal() {
    this.setState({
      closeModalContainer: true,
    });
    setAlertPopUpClickInSession(true);
  }

  /**
   * Function to enable alert popup and firing FPTI
   */
  openAlertModal(alert) {
    const { location } = this.props;
    const pathName = (location && location.pathname) || '';
    const showAlertPopUp = isPopUpWindowAlertEnabled() && !isAlertPopUpClicked() && Array.isArray(alert) && alert.length && !this.state.closeModalContainer;
    if (showAlertPopUp) {
      const fptiPageId = Page.isContactUsPage() ? 'contactUsAlertPopup' : renderPopUpFpti(pathName);
      trackPage({ id: fptiPageId, link: 'smarthelp-crtical-alert-popup' });
    }

    // Checking remote config, session variable, alerts existence and state variable to open the alert
    return showAlertPopUp;
  }

  renderAlertMessage(message) {
    const alertAttribs = {
      className: 'alert-popup-message-info',
      role: message && 'alert',
    };

    const innerHTML = Page.getHTMLElement({ message, useHTML: true });
    return message ? (
      <div {...alertAttribs} ref={(el) => { this.parseContent(el); }}>{innerHTML}</div>
    ) : null;
  }

  renderCriticalAlert() {
    const { alerts } = this.props;
    const criticalAlert = alerts.filter((alert) => (alert && alert.messageType === 'critical'));
    return criticalAlert.map((alert) => alert.message);
  }

  render() {
    const alert = this.renderCriticalAlert();
    return (
      <div className="covid-popup">
        <Modal
          className="covid-popup"
          isOpen={this.openAlertModal(alert)}
          type="dialog"
          width="medium"
          onCancel={() => this.closeModal()}
        >
          <ModalBody>
            <div className="covid-popup-modal">
              <span className="popup-crtical-alert ppvx_icon ppvx_icon--size_xl2 ppvx_icon-critical-alt" />
              <div className="covid-popup-text">{this.renderAlertMessage(alert)}</div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

CovidAlertModalContainer.propTypes = {
  alerts: PropTypes.arrayOf(PropTypes.shape(ALERT)).isRequired,
  location: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    alerts: state.helpcenterAlerts.alerts,
  };
}

export default connect(mapStateToProps)(CovidAlertModalContainer);
